/**
 * @format
 */
import React, { useState } from 'react';
import { ActivityIndicator, Platform, Image } from 'react-native';
// import { Image } from 'react-native-elements';
import FastImage from 'react-native-fast-image';

type Props = {} & any;

const ZTImage: React.FC<Props> = (props: any) => {
  const { style, uri } = props;
  let { resizeMode } = props;
  if (!resizeMode || Platform.OS === 'web') {
    resizeMode = 'cover';
  } else {
    resizeMode = FastImage.resizeMode.cover;
  }
  const [loading, setIsLoading] = useState(true);
  if (Platform.OS === 'web') {
    // console.log(`ExploreImage web for: ${uri}`);
    return (
      <Image
        source={{ uri }}
        style={style}
        {...props}
        // PlaceholderContent={<ActivityIndicator />}
      />
    );
  }
  return (
    <FastImage
      source={{ uri }}
      style={style}
      onLoadStart={() => {
        setIsLoading(true);
      }}
      onLoadEnd={() => {
        setIsLoading(false);
      }}
    >
      <ActivityIndicator
        animating={loading}
        size="large"
        color={'#cccccc'}
        style={style}
      />
    </FastImage>
  );
};

export default ZTImage;
